/**
 * NMS Cart Drawer Scroll Component
 * Handles scroll to cart summary functionality
 */
class NMSCartDrawerScroll extends window.NMSBaseClass {
  constructor() {
    super();
    this.initialized = false;
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    this.bindScrollEvents();
  }

  bindScrollEvents() {
    // Listen for clicks on elements with data-nms-scroll-to attribute
    document.addEventListener('click', (event) => {
      const scrollTarget = event.target.closest('[data-nms-scroll-to]');
      if (scrollTarget) {
        const targetClass = scrollTarget.getAttribute('data-nms-scroll-to');
        event.preventDefault();
        event.stopPropagation();
        this.scrollToElement(targetClass);
      }
    });
  }

  scrollToElement(targetClass) {
    const targetElement = document.querySelector('.' + targetClass);
    if (targetElement) {
      // Check if we're inside a cart drawer with scroll container
      const cartDrawer = document.querySelector('.nms-cart-drawer');
      if (cartDrawer) {
        // Try to find the scroll container within cart drawer
        let scrollContainer;
        try {
          scrollContainer = cartDrawer.shadowRoot?.querySelector('[part="body"]');
        } catch (e) {
          scrollContainer = cartDrawer.querySelector('.nms-cart-drawer__body') || cartDrawer;
        }

        if (scrollContainer && scrollContainer !== cartDrawer) {
          // Scroll within the cart drawer container
          const elementTop = targetElement.offsetTop - scrollContainer.offsetTop;
          scrollContainer.scrollTo({
            top: elementTop,
            behavior: 'smooth'
          });
        } else {
          // Fallback to regular scrollIntoView
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      } else {
        // Regular page scroll
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  }
}

// Initialize component when base class is available
function initCartDrawerScroll() {
  if (typeof window.NMSBaseClass !== 'undefined') {
    window.nmsCartDrawerScroll = new NMSCartDrawerScroll();

    // Auto-initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        window.nmsCartDrawerScroll.init();
      });
    } else {
      window.nmsCartDrawerScroll.init();
    }
  } else {
    setTimeout(initCartDrawerScroll, 100);
  }
}

initCartDrawerScroll();
